// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.verify-email-container p[data-v-f553088e] {\n  font-size: 1.2rem !important;\n  color: var(--bluey-grey);\n}\n.verify-email-container span[data-v-f553088e] {\n  color: var(--sea);\n  font-weight: 600;\n}\n.verify-email-container span[data-v-f553088e]:hover {\n  text-decoration: underline;\n}\n", ""]);
// Exports
module.exports = exports;
